import { render, staticRenderFns } from "./PxRequisicaoUrgenciaIcon.vue?vue&type=template&id=55d6e6f0&scoped=true&"
import script from "./PxRequisicaoUrgenciaIcon.vue?vue&type=script&lang=js&"
export * from "./PxRequisicaoUrgenciaIcon.vue?vue&type=script&lang=js&"
import style0 from "./PxRequisicaoUrgenciaIcon.vue?vue&type=style&index=0&id=55d6e6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d6e6f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
